// src/admin/pages/CreateCategory.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { crearCategoria } from '../../api';
import ImageUploader from '../components/ImageUploader';
import Toast from '../components/Toast';

const tabs = ['IMAGE', 'DETAILS'];

const CreateCategory = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('IMAGE');
  const [toast, setToast] = useState(null);

  const showToast = (type, message) => {
    setToast({ type, message });
    setTimeout(() => setToast(null), 3500);
  };

  const [category, setCategory] = useState({
    nombre: '',
    descripcion: '',
    imagen_url: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategory((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    const { nombre, descripcion, imagen_url } = category;
    if (!nombre || !descripcion || !imagen_url) {
  showToast('warning', 'You must complete all fields.');
      return;
    }

    try {
      await crearCategoria(category);
  showToast('success', 'Category created successfully');
      setTimeout(() => navigate('/admin/categories'), 1500);
    } catch (error) {
  console.error('Error creating category:', error);
  showToast('error', 'Error creating the category. Please try again later.');
    }
  };

  return (
    <div className="p-8 bg-[rgb(var(--color-bg))] min-h-screen text-[rgb(var(--color-text))] font-inter">
      <h1 className="text-3xl font-audiowide mb-6">Create Category</h1>

      <div className="flex border-b border-[rgb(var(--color-border))] mb-6">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`flex items-center gap-2 px-4 py-2 text-sm font-medium transition ${
              activeTab === tab
                ? 'text-blue-400 border-b-2 border-blue-400'
                : 'text-[rgb(var(--color-text))]/70 hover:text-blue-300'
            }`}
          >
            {tab === 'IMAGE' && '📷'}
            {tab === 'DETAILS' && '📐'}
            {tab}
          </button>
        ))}
      </div>

      {activeTab === 'IMAGE' && (
        <div className="space-y-6 max-w-3xl">
          {category.imagen_url && (
            <div className="relative">
              <label className="block mb-2 text-sm text-[rgb(var(--color-text))]/80">Current image</label>
              <img
                src={category.imagen_url}
                alt="Image"
                className="aspect-video w-full object-cover rounded-xl border border-[rgb(var(--color-border))]"
              />
              <button
                onClick={() => setCategory((prev) => ({ ...prev, imagen_url: '' }))}
                className="absolute top-2 right-2 px-3 py-1 text-sm bg-red-600 text-white rounded hover:bg-red-500"
              >
                Remove image
              </button>
            </div>
          )}
          <ImageUploader
            onUpload={(url) => setCategory((prev) => ({ ...prev, imagen_url: url }))}
            onReset={() => setCategory((prev) => ({ ...prev, imagen_url: '' }))}
          />
        </div>
      )}

      {activeTab === 'DETAILS' && (
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm mb-1">Name</label>
            <input
              name="nombre"
              value={category.nombre}
              onChange={handleChange}
              className="w-full p-2 bg-hover-bg border border-[rgb(var(--color-border))] rounded"
            />
          </div>
          <div>
            <label className="block text-sm mb-1">Description</label>
            <textarea
              name="descripcion"
              value={category.descripcion}
              onChange={handleChange}
              className="w-full p-2 bg-hover-bg border border-[rgb(var(--color-border))] rounded h-32"
            />
          </div>
        </div>
      )}

      <div className="flex justify-end mt-10 space-x-3">
        <button
          onClick={() => navigate('/admin/categories')}
          className="px-4 py-2 bg-gray-600 rounded hover:bg-gray-500"
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="px-4 py-2 bg-green-600 rounded hover:bg-green-500 text-white"
        >
          Create category
        </button>
      </div>

      {toast && (
        <Toast
          type={toast.type}
          message={toast.message}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
};

export default CreateCategory;